export const CATEGORY_PRICES_ON_DELETE_REQUESTED = 'CATEGORY_PRICES_ON_DELETE_REQUESTED';
export const CATEGORY_PRICES_ON_DELETE_SUCCEEDED = 'CATEGORY_PRICES_ON_DELETE_SUCCEEDED';
export const CATEGORY_PRICES_ON_DELETE_FAILED = 'CATEGORY_PRICES_ON_DELETE_FAILED';

export const CATEGORY_PRICES_ON_GET_ALL_REQUESTED = 'CATEGORY_PRICES_ON_GET_ALL_REQUESTED';
export const CATEGORY_PRICES_ON_GET_ALL_SUCCEEDED = 'CATEGORY_PRICES_ON_GET_ALL_SUCCEEDED';
export const CATEGORY_PRICES_ON_GET_ALL_FAILED = 'CATEGORY_PRICES_ON_GET_ALL_FAILED';

export const CATEGORY_PRICES_ON_GET_FORM_REQUESTED = 'CATEGORY_PRICES_ON_GET_FORM_REQUESTED';
export const CATEGORY_PRICES_ON_GET_FORM_SUCCEEDED = 'CATEGORY_PRICES_ON_GET_FORM_SUCCEEDED';
export const CATEGORY_PRICES_ON_GET_FORM_FAILED = 'CATEGORY_PRICES_ON_GET_FORM_FAILED';

export const CATEGORY_PRICES_ON_GET_ONE_REQUESTED = 'CATEGORY_PRICES_ON_GET_ONE_REQUESTED';
export const CATEGORY_PRICES_ON_GET_ONE_SUCCEEDED = 'CATEGORY_PRICES_ON_GET_ONE_SUCCEEDED';
export const CATEGORY_PRICES_ON_GET_ONE_FAILED = 'CATEGORY_PRICES_ON_GET_ONE_FAILED';

export const CATEGORY_PRICES_ON_SAVE_REQUESTED = 'CATEGORY_PRICES_ON_SAVE_REQUESTED';
export const CATEGORY_PRICES_ON_SAVE_SUCCEEDED = 'CATEGORY_PRICES_ON_SAVE_SUCCEEDED';
export const CATEGORY_PRICES_ON_SAVE_FAILED = 'CATEGORY_PRICES_ON_SAVE_FAILED';
